import { FC } from 'react';
import { Gallery } from '#advertDetail/components/gallery';
import { SocialLinkList } from '#advertDetail/components/social-link';
import { Location } from '#advertDetail/components/Location';
import { Phone } from '#advertDetail/components/Phone';
import { ContactList } from '#advertDetail/components/contact-list';
import { PriceList } from '#advertDetail/components/price-list';
import { ParameterList } from '#advertDetail/components/parameter-list';
import { ServiceList } from '#advertDetail/components/service-list';
import { H1 } from '#advertDetail/components/h1';
import modelDetailCss from '../assets/model-detail/model-detail.module.scss';
import modelDetailContactListCss from '../assets/model-detail/model-detail-contact-list.module.scss';

const Info: FC = () => (
  <div className={modelDetailCss.modelDetail}>
    <div className={modelDetailCss.modelDetail__inner}>
      <div className={modelDetailCss.modelDetail__top}>
        <H1 />
        <div className={modelDetailContactListCss.modelDetailContactList}>
          <Location />
          <Phone />
        </div>
      </div>
      <Gallery />
      <div className={modelDetailCss.modelDetail__info}>
        <ContactList />
        <PriceList />
        <ParameterList />
        <ServiceList />
        <SocialLinkList />
      </div>
    </div>
  </div>
);

export { Info };
